// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form_Form__1YO6S","Area":"Form_Area__A5WVl","Result":"Form_Result__1jtpx","Submit":"Form_Submit__3sjKz","Modal":"Form_Modal__2E-un"};